import { render, staticRenderFns } from "./FullEndorsementList.vue?vue&type=template&id=f51aa7ec&"
import script from "./FullEndorsementList.vue?vue&type=script&lang=js&"
export * from "./FullEndorsementList.vue?vue&type=script&lang=js&"
import style0 from "./FullEndorsementList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports